import { LeafProps, ScommesseLeafItem } from './types';

import { EsitoCell } from './EsitoCell';
import { InfoAggiuntivaCell } from './InfoAggiuntivaCell';
import { QuotaCell } from './QuotaCell';
import { isTruthy } from 'utility/functions';
import { useMemo } from 'react';

export { ScommesseLeafItem } from './types';
export type { ScommesseLeafItemType, ScommesseLeafItemProps, LeafProps } from './types';

export function decodeEsitoPartial<T>(input: T, isInfoAgg: boolean = false): string {
  let quote = 0;
  if (typeof input === 'string') {
    if (input === '-' || !isTruthy(input?.length)) return '-';

    quote = parseFloat(input);
  } else {
    quote = parseFloat(`${input}`);
  }

  if (isNaN(quote)) {
    return `${input}`;
  }

  if (quote < 10 && !isInfoAgg) {
    return quote.toFixed(2);
  }

  return `${quote}`;
}

export function decodeEsitoValue<T>(input: T, isInfoAgg: boolean = false): string {
  const inputString = `${input}`.split('-');
  if (inputString.length === 2) {
    const list = inputString.map((x) => decodeEsitoPartial(x.trim(), isInfoAgg));
    const hasValue = list.some((element) => element !== '-');
    if (hasValue) {
      return list.join('-');
    }
    return '-';
  }
  return decodeEsitoPartial(input, isInfoAgg);
}

export const Leaf = ({ type, ...oth }: LeafProps) => {
  const Item = useMemo(() => {
    switch (type) {
      case ScommesseLeafItem.Quota: {
        return QuotaCell;
      }
      case ScommesseLeafItem.MarcatoriInfoAgg:
      case ScommesseLeafItem.InfoAggiuntiva:
      case ScommesseLeafItem.InfoAggiuntivaWithEsito: {
        return InfoAggiuntivaCell;
      }
      case ScommesseLeafItem.Esito: {
        return EsitoCell;
      }
      default: {
        throw new Error(`Leaf: unmanaged option ${type}`);
      }
    }
  }, [type]);

  return <Item {...oth} />;
};
